import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { mapQueryStringToFilterObject, convertQueryObjToString } from '../../utils/filters-util';

const usePaginationGuard = ({ selector, listKey, onRefetch = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = useSelector(selector) || {};
  const pagination = state?.pagination || {};
  const rows = listKey ? state?.[listKey]?.length : undefined;

  return (delta = -1) => {
    const queryObj = mapQueryStringToFilterObject(location.search || '')?.queryObj || {};
    const items = Number(pagination?.items) || Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 10;
    const currentPage = Number(queryObj?.page) || Number(pagination?.page) || 1;
    const newCount = Math.max(0, (Number(pagination?.count) || 0) + delta);

    const rowsBefore =
      rows != null ? rows : Math.max(0, Math.min(items, (Number(pagination?.count) || 0) - (currentPage - 1) * items));

    if (rowsBefore + delta > 0) return;

    const goTo = (page) =>
      navigate({ pathname: location.pathname, search: convertQueryObjToString({ ...queryObj, page }) });

    if (newCount === 0) {
      if (currentPage !== 1) goTo(1);
      return;
    }

    const totalPages = items > 0 ? Math.ceil(newCount / items) : 0;
    if (currentPage > totalPages) {
      goTo(currentPage - 1);
    } else {
      onRefetch();
    }
  };
};

export default usePaginationGuard;
